import type { Profile } from "@/core/types";

export const shouldUpdateInsurance = (profile: Profile): boolean => {
  const insurance_status = profile?.chc_info?.status;
  const show_insurance_task = ["declined", "no_match"];

  return show_insurance_task.includes(insurance_status);
};
